import { Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import Preview from "../Preview/preview";
import "../table/viewMicrosite.scss";

export default function ViewMicrositeDetailsDeleted({
  orgId,
  closeModal,
}) {
  const [loading, setLoading] = useState(true);
  const [oneOrgData, setOneOrgData] = useState(null);
  const [microsite, setMicrosite] = useState(null);
  //   const modalIn = sessionStorage.getItem("modal from member or restore");

  const getOneOrganizationData = async () => {
    try {
      setLoading(true)
      const response = await getRequest(
        userServiceApi.getOneOrganizationDeleted(orgId)
      );
      // console.log(response, "ressponse");

      if (response.data) {
        setOneOrgData(response.data);
      }
    } catch (error) {
      toast.error(error.error);
    }
    finally {
      setLoading(false)
    }
  };

  const RemoveMicrosite = () => {
    setMicrosite(null);
  };

  const handleCancel = () => {
    closeModal();
  };

  useEffect(() => {
    getOneOrganizationData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId]);

  return (
    <Modal
      open={true}
      onCancel={handleCancel}
      // closeIcon={<img className="closeIcon" src={closeIcon} />}
      footer={null}
      className="viewMicrositeModal"
    >
      {loading ? (
        <div className="data-loader">
          <Spin className="spin" tip="Loading" size="large" />
        </div>
      ) : (
        <div className="approve-container">

          {oneOrgData?.mediaLink ? (
            <div style={{ textAlign: 'center' }}>
              <img
                src={oneOrgData?.mediaLink}
                alt={""}
                className="preview-image"
                width={60}
              /></div>
          ) : null}
          <div className="partnerInfoStyle">

            {/* {oneOrgData?.mediaLink ? (
              <div className="partnerInfoRow">
                <div className="partnerInfoCol">
                  <div className="img-container">
                    <img
                      src={oneOrgData?.mediaLink}
                      alt={""}
                      className="preview-image"
                      width={60}
                    />
                  </div>
                </div>
                <div className="partnerInfoCol">
                  <div className="btn-container">
                     {microsites.map((microsite) => {
                       return (
                         <div className="inputBody-btns">
                           <Button
                             className="view-btn"
                             type="button"
                             onClick={() => ShowSubsectionhandler(microsite.id)}
                           >
                             View Site
                           </Button>
                         </div>
                       );
                     })}
                   </div>
                </div>
              </div>
            ) : null} */}

            <div className="partnerInfoRow">
              <div className="partnerInfoCol">Name</div>
              <div className="partnerInfoCol">{oneOrgData?.name}</div>
            </div>
            <div className="partnerInfoRow">
              <div className="partnerInfoCol">Type</div>
              <div className="partnerInfoCol">{oneOrgData?.type?.length > 0 ? oneOrgData?.type : ""}</div>
            </div>
            <div className="partnerInfoRow">
              <div className="partnerInfoCol">Size</div>
              <div className="partnerInfoCol">
                {oneOrgData?.size === "MICRO"
                  ? "Micro"
                  : oneOrgData?.size === "SMALL"
                    ? "Small"
                    : oneOrgData?.size === "MEDIUM"
                      ? "Medium"
                      : oneOrgData?.size === "LARGE"
                        ? "Large"
                        : ""}
              </div>
            </div>
            {Array.isArray(oneOrgData?.sectorsOutputs) &&
              oneOrgData.sectorsOutputs.length > 0 &&
              oneOrgData.sectorsOutputs[0]?.sectorOutput?.name && (
                <div className="partnerInfoRow">
                  <div className="partnerInfoCol">Categories</div>
                  <div className="partnerInfoCol">
                    {oneOrgData.sectorsOutputs[0].sectorOutput.name}
                  </div>
                </div>
              )}

            {Array.isArray(oneOrgData?.sectorsOutputs) &&
              oneOrgData.sectorsOutputs.length > 0 &&
              oneOrgData.sectorsOutputs[0]?.subSectorOutput?.name && (
                <div className="partnerInfoRow">
                  <div className="partnerInfoCol">Sub categories</div>
                  <div className="partnerInfoCol">
                    {oneOrgData.sectorsOutputs[0].subSectorOutput.name}
                  </div>
                </div>
              )}

            {oneOrgData?.websiteLink ? (
              <div className="partnerInfoRow">
                <div className="partnerInfoCol">Website</div>
                <div className="partnerInfoCol"> {oneOrgData?.websiteLink}</div>
              </div>
            ) : null}

            <div className="partnerInfoRow">
              <div className="partnerInfoCol">Email</div>
              <div className="partnerInfoCol"> {oneOrgData?.email}</div>
            </div>
            <div className="partnerInfoRow">
              <div className="partnerInfoCol">Phone</div>
              <div className="partnerInfoCol">{oneOrgData?.phone}</div>
            </div>
            <div className="partnerInfoRow">
              <div className="partnerInfoCol">Address</div>
              <div className="partnerInfoCol">
                {oneOrgData?.addressOutputs.map((address) => {
                  return address.street;
                })}</div>
            </div>
          </div>
        </div>
      )}

      {microsite ? (
        <Preview micrositeId={microsite} RemoveMicrosite={RemoveMicrosite} />
      ) : (
        <></>
      )}
    </Modal>
  );
}
